/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerUserConfig } from '../../config/header.config';
export interface IHeaderUserPluginMethods extends IPluginMethodMap {
  getHeaderUserSync(args?: any): any;
}

export class HeaderUserPlugin implements IAgentPlugin {
  readonly methods: IHeaderUserPluginMethods;

  constructor() {
    this.methods = {
      getHeaderUserSync: this.getHeaderUserSync.bind(this),
    };
  }

  getHeaderUserSync(args?: any) {
    return {
      header: headerUserConfig,
    };
  }
}
